export const MOBILE_DIMENSIONS = {
    width: 360,
    height: 640
  };
export const BASE_URL = 'https://ecardly.pro';
export const BASE_URL_SHARE = 'https://ecardly.me';